module.exports = __webpack_public_path__ + "static/media/taxijoin_03.e01a129f.png";